import React, { useRef } from "react";
import { useState, useEffect } from "react";
import Link from "next/link";

const CurrentAffairsCategories = () => {
  const [latestCategories, setLatestCategories] = useState(null);

  const scollToRef = useRef();

  useEffect(() => {
    const getLatestCategories = async () => {
      const url = `https://api.toppersnotes.com/api/ca/categories`;
      let data = await fetch(url);

      let parsedData = await data.json();
      setLatestCategories(parsedData);
    };
    getLatestCategories();
  }, []);

  useEffect(() => {
    const scrollWin = () => {
      if (localStorage.getItem("blogScrol")) {
        scollToRef && scollToRef.current && scollToRef.current.scrollIntoView();
        // window.scrollTo(0, 600);
        localStorage.removeItem("blogScrol", false);
      }
    };
    scrollWin();
  }, []);

  return (
    <div className="container" ref={scollToRef}>
      <div className="row my-8">
        <div
          id="scrollId"
          className="flex justify-center text-3xl font-bold h-20"
        >
          Category Wise Current Affairs
        </div>
        {/* {data
              ? data.slice(1, 2).map((categories) => ( */}
        {latestCategories
          ? latestCategories.map((category) => {
              return (
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <div className="single-categories-box">
                    {/* {categories.icon} */}
                    <img
                      src={category && category.icon}
                      className=" h-48"
                      alt="image"
                    />

                    <div className="content">
                      <h6 className="text-xl text-white font-bold mb-2">
                        {category && category.name}
                      </h6>
                      <span className="text-xs">
                        {<>{category && category.articles_count} Articles</>}
                      </span>
                    </div>

                    <Link href={`/blog/${category.slug}`}>
                      <a className="link-btn"></a>
                    </Link>
                  </div>
                </div>
              );
            })
          : "Loading..."}

        {/*    ))
              : "Loading" */}
      </div>
    </div>
  );
};

export default CurrentAffairsCategories;
